import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';

import User from 'entity/User';
import UserController from 'rest/UserController';

@Injectable()
export class UserService {
  private userController: UserController;
  public constructor() {
    this.userController = new UserController();
  }

  public getCurrentUser(): Observable<User> {
    return from(this.userController.getCurrentUser());
  }

  public getUserByMobile(mobile: string): Observable<User> {
    return from(this.userController.getUserByMobilePhone(mobile));
  }

  public getUserByEmail(email: string): Observable<User> {
    return from(this.userController.getUserByEmail(email));
  }

  public getUserByUserId(userId: string): Observable<User> {
    return from(this.userController.getUser(userId));
  }

  public getUserById(userId: string): Promise<User> {
    return this.userController.getUser(userId);
  }

  public setUserEmail(email: string): Observable<void> {
    return from(this.userController.addEmail(email));
  }

  public updateUser(user: User): Observable<User> {
    return from(this.userController.updateUser(user));
  }

  public addGuestEmail(email: string): Promise<void> {
    return this.userController.addGuestEmail(email);
  }
}
